'use es6';

export default ((contentId, reviewData) => {
  if (!contentId || !reviewData || !reviewData.get('reviewList')) return false;
  return reviewData.get('reviewList').has(contentId.toString());
});